import React from "react";
import { useInView } from "./useInView"; // 경로 주의

export default function LazyImage({ src, alt = "", ...rest }) {
  const [ref, inView] = useInView({ rootMargin: "700px 0px" }); // 스크롤 여유

  return (
    <img
      ref={ref}
      src={inView ? src : undefined}
      alt={alt}
      loading="lazy"
      {...rest}
    />
  );
}
